<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">LOGS</li>
            </ol>
        </nav>
    </div>
</div>
<!--end breadcrumb-->
<div class="row">
    <div class="col-md-2" *ngIf="admin == 'true'">
        <select class="form-select" [(ngModel)]="selected_details.ltype" (change)="onLTypeChanged()">
      <option *ngFor="let lt of ltypes" [value]="lt._id"> {{ lt.name }}</option>
    </select>
    </div>
    <div class="col-md-2" *ngIf="admin == 'true'">
        <select class="form-select" [(ngModel)]="selected_details.user" (change)="onUserChanged()">
      <option *ngFor="let s of users" [value]="s._id"> {{ s.full_name }}</option>
    </select>
    </div>
    <div class="col-md-2">
        <select class="form-select" [(ngModel)]="selected_details.user_strategy" (change)="onUserStrategyChanged()">
      <option *ngFor="let us of userStrategies" [value]="us._id"> {{ us.display_name }}</option>
    </select>
    </div>
    <div class="btn-group col-md-3">
        <input type="date" name="" class="form-control mr" [(ngModel)]="logDate">
        <button class="btn btn-primary" (click)="loadLogs()">Load</button>
    </div>
</div>
<nav *ngIf="selected_details.ltype == 'state' && admin == 'true'">
    <div class="nav nav-tabs" id="log-nav-tab" role="tablist">
        <a class="nav-link active" id="nav-detail-tab" data-bs-toggle="tab" href="#nav-detail" role="tab" aria-controls="nav-detail" aria-selected="true" (click)="onTabSelected('detail')">Detailed</a>
        <a class="nav-link" id="nav-short-tab" data-bs-toggle="tab" href="#nav-short" role="tab" aria-controls="nav-short" aria-selected="false" (click)="onTabSelected('short')">Short</a>
    </div>
</nav>
<div class="tab-content" id="logTabContent" *ngIf="selected_details.ltype == 'state' && admin == 'true'">
    <div class="tab-pane fade show active" [ngClass]="tabInfo.detailCls" id="detail" role="tabpanel" aria-labelledby="detail-tab">
        <ngx-json-viewer [json]="state.detail"></ngx-json-viewer>
    </div>
    <div class="tab-pane fade" id="short" [ngClass]="tabInfo.shortCls" role="tabpanel" aria-labelledby="short-tab">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col" *ngFor="let c of state.short.cols">{{ c }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let r of state.short.rows">
                    <th scope="row">{{ r['#'] }}</th>
                    <td *ngFor="let c of state.short.cols">{{ r[c] }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="card mt-3" *ngIf="selected_details.ltype == 'log'">
    <div class="card-body">
        <div class="table-responsive mt-3">
            <table class="table align-middle">
                <thead class="table-secondary">
                    <tr>
                        <th>Datetime</th>
                        <th>Message</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let log of logs" ng-if="logs.length > 0">
                        <td>
                            {{ log.dtt }}
                        </td>
                        <td>
                            {{ log.msg }}
                        </td>
                    </tr>
                    <tr *ngIf="logs.length == 0">
                        <td class="text-center" colspan="2">No Logs Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div *ngIf="admin == 'false'" class="mt-3">
    <table class="table table-striped" *ngIf="state.short.rows.length > 0">
        <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col" *ngFor="let c of state.short.cols">{{ c }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let r of state.short.rows">
                <th scope="row">{{ r['#'] }}</th>
                <td *ngFor="let c of state.short.cols">{{ r[c] }}</td>
            </tr>
        </tbody>
    </table>
    <p class="fs-6" *ngIf="state.short.rows.length == 0">No Logs Found</p>
</div>
